(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cookie-consent-box", [], factory);
	else if(typeof exports === 'object')
		exports["cookie-consent-box"] = factory();
	else
		root["cookie-consent-box"] = factory();
})(window, function() {
return 